import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {VanillaReaderUiMenuMediaPlayerController} from "./VanillaReaderUiMenuMediaPlayerController";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUI} from "./VanillaReaderUI";

export interface VanillaReaderUiFabMediaPlayerController extends IVanillaReaderUiComponentController, IVanillaReaderUI, VanillaReaderUiMenuMediaPlayerController {}

/**
 * # VanillaReaderUiFabMediaPlayerController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiFabMediaPlayer` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiFabMediaPlayer
 *
 */
export class VanillaReaderUiFabMediaPlayerController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.fabMediaPlayer.onClick(vanillaReaderUiContext._onFabMediaPlayerClicked.bind(vanillaReaderUiContext));
    }

    _onFabMediaPlayerClicked(): void {
        if (!this.menuMediaPlayer.stateIsPlaying) {
            this.startPlayback();
        } else {
            this.pausePlayback();
        }
    };

}
